<template>
    <div class="page mixologistSingle" @scroll="pageScroll" ref="page">
        
            <div class="recipeContainer">
                <div class="pageContainer">
                    <div class="container">
                        <h2 class="d-flex jus">
                            <span><img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)"
                                       alt="back"></span>
                            <span class="text-center flex-grow-1">{{currentMixologist.name }}</span>
                            
                            <span style="width: 35px"></span>
                        </h2>
                        <p class="text-center">
                            {{ currentMixologist.subheadline }}
                        </p>

                        <div class="video mt-5 mb-5" v-if="currentMixologist.video">
                            <iframe :src="currentMixologist.video"></iframe>
                        </div>
                        <div v-else>
                            <img class="w-100 mb-5" :src="currentMixologist.primary_image">
                        </div>

                        <div class="row">
                            <div class="col-md-6 recipeCard mr-3 ml-3 mt-0 mb-4">
                                <h2>{{ currentMixologist.headline }}</h2>
                                <p class="">{{ currentMixologist.section_1_text }}</p>
                            </div>
                            <div class="col-md-6 mt-3">
                                <img class="w-100" :src="currentMixologist.inline_image_1">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mt-5 order-md-1 recipeCard mr-3 ml-3 mt-0 mb-4">
                                <p class="">{{ currentMixologist.section_2_text }}</p>
                            </div>
                            <div class="col-md-6 mt-3">
                                <img class="w-100" :src="currentMixologist.inline_image_2">
                            </div>
                        </div>

                        <div class="recipeCard">
                            <div class="row">
                                <div class="col-md-12">
                                    <h2 class="text-center">{{ currentMixologist.recipe_title }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    
                                    <img class="w-100 mb-4" :src="currentMixologist.recipe_image">
                                </div>
                                <div class="col-md-6">
                                    <h5>Created by {{ currentMixologist.name }}</h5>
                                    <p>{{ currentMixologist.recipe_description }}</p>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h5>Ingredients</h5>
                                            <div v-html="currentMixologist.recipe_ingredients"></div>
                                        </div>
                                        <div class="col-md-6">
                                            <h5>Directions</h5>
                                            <div class="bodyText" v-html="currentMixologist.recipe_directions"></div>
                                            
                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <div class="actions">
                                                <span @click="shareThis({ title: currentMixologist.name, text: '', url: href})">
                                                    <img width="24" :src="getStaticImage('icon-share.png')">
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="relatedRecipes mt-5">
                            <div class="row">
                                <div class="col-md-12">
                                    <h2 class="text-center">Recipes to explore</h2>
                                </div>
                            </div>
                            <div
                                class="sliderBox"
                                v-if="currentProduct.recipes"
                            >
                                <!--v-touch:swipe.stop-->
                                
                               
                                <div class="slideContainer">
                                    <div class="slideRecipes">
                                        <div v-for="recipe in currentProduct.recipes.data" class="slide">
                                            <router-link :to="{name:'recipes', query : { recipe : recipe.id  } }">
                                                
                                                <div class="imgBox">
                                                    <img :src="recipe.image ? recipe.image : getStaticImage('logo.png') " alt="">
                                                </div>
                                                {{recipe.title}}
                                            </router-link>
                                        </div>
                                        
                                        <div class="slide last">
                                            <router-link class="d-flex align-items-center justify-content-center"
                                                        :to="{name:'recipes', query : { filter : currentProduct.filter  } }">
                                                <span class="mkButton mkBig">{{ $t('product.View All') }}</span>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                
                        </div>
                        
                    </div>
                </div>
                
                
                
               
            
            </div>
    
    </div>
</template>

<script>

    import {mapState} from "vuex";
    import shareMixin from "../mixins/share"
    import pageMixin from "../mixins/page";
    import VRuntimeTemplate from "v-runtime-template";
    import Loader from "./Loader";
    import $ from "jquery";
    import Flickity from 'flickity';
    import "slick-carousel";
    import 'flickity/dist/flickity.min.css';

    export default {
        name: 'MixologistSingle',
        components: {VRuntimeTemplate, Loader},
        mixins:[shareMixin, pageMixin],
        data() {
            return {
                flickity: null,
                flickityOptions: {
                    freeScroll: true,
                    // any options from Flickity can be used
                },
                href: window.location.href
            }
        },
        computed: {
          ...mapState("mixologist",["currentMixologist"] ),
          ...mapState("product", ["currentProduct"])
        },
        methods: {
            initSlick() {
                $(".slickSlider").slick({
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 5000,
                });
            },
            initProduct() {
                //##########################
                // this.changePageTitle( this.currentMixolgist.name + "  | ABM Cocktail Pro" );
                let self = this;
                setTimeout(function () { //waiting before everything is gonna show
                    

                    if ($('.slideRecipes').length) {
                        // alert('slideRecipes');
                        /*$('.slideRecipes').slick({
                            dots:false,
                            arrows: false,
                            slidesToShow: 2.1,
                            centerMode: true,
                            infinite: false
                        });*/

                        const lenght = $('.slideRecipes .slide').length

                        self.flickity = new Flickity('.slideRecipes', {
                            freeScroll: true,
                            contain: true,
                            prevNextButtons: false,
                            pageDots: false
                        });

                        let tapArea, startX ;
                        tapArea = document.querySelectorAll('.slide');
                        startX = 0;
                        for (let item of tapArea) {
                            item.ontouchstart = function(e) {
                                startX = e.touches[0].clientX;
                            };
                            item.ontouchmove = function(e) {
                                if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
                                    e.preventDefault();
                                }
                            };
                        }
                        
                    } else {
                        delete self.flickity;
                    }
                }, 500);
            },
            resizeFlickity() {
                if (this.flickity) {
                    this.flickity.resize();
                    document.querySelector('.flickity-viewport').style.height = null;
                }

            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            },
            init() {
                
                    // this.$store.dispatch("product/getProduct", 1);
            },

        },
        created() {
            // this.init();
            this.$store.dispatch("mixologist/getMixologist", this.$route.query.mixologist);
            var prods = [2,3,4,5,7,8,9,10,11,12,13,14,15,16,17,18,19,21,157,158,170,177,178,179];
            var product = prods[Math.floor(Math.random()*prods.length)]
            this.$store.dispatch("product/getProduct", product);
            this.initProduct();
            window.addEventListener("resize", this.resizeFlickity.bind(this));
        },
        beforeUpdate() {
            $(".slickSlider").slick('unslick');
        },
        updated() {
            this.initSlick();
        },
        destroyed() {
        },
        watch: {
            currentProduct() {
                this.initProduct();
            }
        }
    }
</script>

